import { useState } from "react";
import filterItem from "../../../Data/DataFilterFreeContent";
import SelectSocialNetwork from "./SubModalFilter/SelectSocialNetwork";
import TextFilter from "./SubModalFilter/TextFilter";
import ModalTitle from "../../SubDashboard/ModalTitle/ModalTitle";
import ModalButton from "../../SubDashboard/ModalButton/ModalButton";

function ModalFilterFreeContent({ closeModal }) {

    const [socialNetwork, setSocialNetwork] = useState("")
    const [title, setTitle] = useState("")
    const [link, setLink] = useState("")
    const [description, setDescription] = useState("")

    const chooseSocialNetwork = (value) => {
        setSocialNetwork(value)
    }
    const chooseTitle = (value) => {
        setTitle(value)
        console.log(value)
    }
    const chooseLink = (value) => {
        setLink(value)
    }
    const chooseDescription = (value) => {
        setDescription(value)
    }

    const chooseAction = () => {
        filterItem.socialNetwork = socialNetwork
        filterItem.title = title
        filterItem.link = link
        filterItem.description = description
        closeModal(false)
    }
    const chooseCancel = () => {
        filterItem.socialNetwork = ""
        filterItem.title = ""
        filterItem.link = ""
        filterItem.description = ""
        closeModal(false)
    }


    return (
        <>
            <div className="fixed top-0 left-0 bg-black opacity-40 w-screen h-screen"></div>
            <div className="fixed top-40 left-1/4 w-2/4 h-2/4 bg-white rounded-lg shadow">

                <ModalTitle
                    title="جستجو"
                    closeModal={chooseCancel}
                />

                <div className="bg-slate-100 border border-slate-200 rounded m-2 px-8 py-8 text-right mb-12">
                    <SelectSocialNetwork chooseValue={chooseSocialNetwork} />
                    <TextFilter title=": عنوان" chooseText={chooseTitle} />
                    <TextFilter title=": لینک" chooseText={chooseLink} />
                    <TextFilter title=": توضیحات" chooseText={chooseDescription} />
                    <p>{title}</p>
                </div>

                <ModalButton
                    chooseAction={chooseAction}
                    chooseCancel={chooseCancel}
                />

            </div>
        </>
    )
}
export default ModalFilterFreeContent;